import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  IUpdateReleaseDatePayload,
  ActionType,
  UpdateReleaseDateResponse,
} from "models/userListBusiness/updateReleaseDate";
import { httpStatus } from "configs/httpStatus";
import { updateReleaseDate } from "services/userListBusiness";
import {
  handleSuccesAction,
  handleErrorAction,
} from "./updateReleaseDateActions";

function* updateReleaseDateSaga({
  payload,
}: {
  payload: IUpdateReleaseDatePayload;
}) {
  try {
    const response: UpdateReleaseDateResponse = yield call(
      updateReleaseDate,
      payload
    );
    if (
      response.status === httpStatus.StatusOK ||
      response.status === httpStatus.StatusCreated ||
      response.status === httpStatus.StatusUnprocessableEntity
    ) {
      yield put(handleSuccesAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onUpdateReleaseDateWatcher() {
  yield takeLatest(
    ActionType.UPDATE_RELEASE_DATE as any,
    updateReleaseDateSaga
  );
}

export default [fork(onUpdateReleaseDateWatcher)];
